import { useState, useCallback } from 'react';
import { globalColorManager } from '../../../utils/ColorManager';

/**
 * Path Color Management Hook
 * Responsible for managing color assignments for VRP paths
 */
export const useVehiclePathColors = (initialColors = new Set()) => {
  // Track used colors to avoid duplicates
  const [usedColors, setUsedColors] = useState(initialColors);
  
  // Generate a color using the unified color management system
  const getVehicleColor = useCallback((vehicleId, vehicleData = {}) => {
    const color = globalColorManager.getVehicleColor(vehicleId, vehicleData);
    
    // Update local used colors tracking for UI purposes
    setUsedColors(prev => new Set([...prev, color]));
    
    return color;
  }, []);

  // Update the set of used colors
  const updateUsedColors = useCallback((colors) => {
    if (colors instanceof Set) {
      setUsedColors(colors);
    } else if (Array.isArray(colors)) {
      setUsedColors(new Set(colors));
    }
  }, []);
  
  // Reset the color set
  const resetColors = useCallback(() => {
    globalColorManager.reset();
    setUsedColors(new Set());
  }, []);
  
  return {
    usedColors,
    getVehicleColor,
    updateUsedColors,
    resetColors
  };
}; 